import React from 'react';
import Card from '@mui/material/Card';
import ProfileServices from '../../Services/ProfileServices';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import DashboardServices from '../../Services/DashboardServices';
import { Box, IconButton, Stack, Typography, LinearProgress, Chip, Button, Collapse } from '@mui/material';
import Header from '../../Components/Header/Header';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';

import Link from '@mui/material/Link';
import Swal from "sweetalert2";
import { ShowAlert } from "../../Components/ShowAlert";
import FilterListIcon from '@mui/icons-material/FilterList';
import { Menu, MenuList, MenuItem, ListItemText } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import FormServices from '../../Services/FormServices';
import { ShowBlocker } from '../../Components/LoaderComponent/LoaderComponent';
import CSEDDetails from '../CSEDDetails/CSEDDetails';
import { createRoot } from 'react-dom/client';
import UserEligiblePlans from '../EligiblePlans/UserEligiblePlans';
import { amountFormat } from '../../Components/helper';

interface DashboardUser {
  userId: string;
  email: string;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  userName: string;
  form8821ResubFlag: boolean;
  form433AResubFlag: boolean;
  form433DResubFlag: boolean;
  actionRequired: boolean;
  isJointTaxpayer: boolean;
  accountType: number;
  helpText: string;
  subStatus: string;
  isPersonaCompleted: boolean;
  personaInqId: string;
  totalAmountOwed: string;
  form8821EnvelopeId: string;
  form8821Docusign: boolean;
  isForm8821Approved: boolean;
  form433AEnvelopeId: string;
  form433ADocusign: boolean;
}

interface DashboardColumn {
  checklistName: string;
  checklistId: number;
  totalCount: number;
  users: DashboardUser[];
  currentPage: number;
  hasLoadMore: boolean;
}

interface CaseDashboardData {
  accessToken: string;
  tenantIndex: number;
  results: DashboardColumn[];
  expandedCards: string[];
  // currentPage: number;
  subject: string;
  body: string;
  searchText: string;
  filterAnchorEl: HTMLElement | null;
  filterColumn: string;
  selectedFilters: any;
}

class CaseDashboard extends React.Component<{}, CaseDashboardData> {
  constructor(props: any) {
    super(props);
    this.state = {
      accessToken: '',
      tenantIndex: 1,
      results: [],
      expandedCards: [],
      // currentPage: 1,
      subject: '',
      body: '',
      searchText: '',
      filterAnchorEl: null,
      filterColumn: '',
      selectedFilters: {}
    };
  }

  async componentDidMount() {
    const accesstoken = await loadFromLocalStorage('accessToken');

    if (accesstoken) {
      this.setState({
        accessToken: accesstoken.toString()
      }, () => {
        this.getCaseDashboardDetails();
      })

    }
    else {
      localStorage.clear();
      window.location.href = '/'
    }

    const tenantData = JSON.parse(localStorage.getItem('TENANT_CONFIG') || '{}');
    this.setState({
      tenantIndex: tenantData?.tenant_index
    });
  }

  private handleSearch = (searchText: string) => {
    this.setState({
      searchText: searchText,
      selectedFilters: {},
      filterAnchorEl: null,
      filterColumn: '',
    });
    this.getCaseDashboardDetails(searchText);
  };

  private toggleCard(userId: string) {
    this.setState((prevState) => ({
      expandedCards: prevState.expandedCards.includes(userId)
        ? prevState.expandedCards.filter(id => id !== userId)
        : [...prevState.expandedCards, userId]
    }));
  }

  private handleLoadMore = (col: DashboardColumn) => {
    this.getPagingCaseDashBoard(col.checklistId, this.state.searchText);
  };

  handleFilterClick = (checklistName: string, event: React.MouseEvent<HTMLElement>) => {
    this.setState({
      filterAnchorEl: event.currentTarget,
      filterColumn: checklistName
    });
  };

  handleFilterClose = () => {
    this.setState({
      filterAnchorEl: null,
    });
  };

  handleFilterChange = (
    event: React.MouseEvent<HTMLElement>,
    checklistId: number
  ) => {

    const menuItem = (event.target as HTMLElement).closest(
      '[data-value]'
    ) as HTMLElement | null;

    if (!menuItem) return;

    const value = menuItem.dataset.value;

    const { filterColumn } = this.state;

    if (!filterColumn || !value) {
      return;
    }
    if (this.state.selectedFilters[this.state.filterColumn] === value) {
      const selectedFilters = {
        ...this.state.selectedFilters,
        [filterColumn]: null,
      }
      delete selectedFilters[filterColumn];

      this.setState({
        selectedFilters: selectedFilters,
        filterAnchorEl: null,
        filterColumn: '',
      });
      this.getPagingCaseDashBoard(checklistId, this.state.searchText, null, true);
    }
    else {
      const selectedFilters = {
        ...this.state.selectedFilters,
        [filterColumn]: value,
      };
      this.setState({
        selectedFilters: selectedFilters,
        filterAnchorEl: null,
        filterColumn: '',
      });
      this.getPagingCaseDashBoard(checklistId, this.state.searchText, { [filterColumn]: value }, true);
    }
  };

  filterOptions = (checklistId: number) => {
    switch (checklistId) {
      case 3:
        return [
          { value: 'Pending', label: 'Pending' },
          { value: 'Pending Sign', label: 'Pending Sign' },
          { value: 'Signed', label: 'Signed' },
          { value: 'IRS Submitted', label: 'IRS Submitted' },
          // { value: 'IRS Approved', label: 'IRS Approved' }
        ];
      case 9:
        return [
          { value: 'Pending', label: 'Pending' },
          // { value: 'Completed', label: 'Completed' },
          { value: 'Cancelled', label: 'Cancelled' },
          // { value: 'Approved', label: 'Approved' },
          { value: 'Failed', label: 'Failed' }
        ];
      default:
        return []
    }
  }

  renderFilterHeader = (col: DashboardColumn) => {
    const filterKey = col.checklistName.replaceAll(' ', '_');
    let options = this.filterOptions(col.checklistId);
    return (
      <>
        <IconButton
          id={filterKey}
          size="small"
          onClick={(event) =>
            this.handleFilterClick(filterKey, event)
          }
        >
          <FilterListIcon fontSize="small" />
        </IconButton>

        <Menu
          id={`${filterKey}-menu`}
          anchorEl={this.state.filterAnchorEl}
          open={Boolean(this.state.filterAnchorEl) &&
            this.state.filterColumn === filterKey}
          onClose={this.handleFilterClose}
        >
          <MenuList onClick={(event) =>
            this.handleFilterChange(event, col.checklistId)
          }>
            {options.map((option) => (
              <MenuItem
                key={option.value}
                data-value={option.value}
                selected={this.state.selectedFilters[filterKey] === option.value}
              >
                <ListItemText primary={option.label} />

                {this.state.selectedFilters[filterKey] === option.value && (
                  <CheckIcon fontSize="small" sx={{ ml: 1 }} />
                )}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </>
    );
  };

  render() {
    return (
      <>
        <Header onSearch={this.handleSearch} />
        <Box sx={{ width: '100%', p: 2, bgcolor: '#F4F7F9', minHeight: '100vh' }}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              overflowX: 'auto',
              pb: 2,
              // Custom scrollbar for better appearance
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': { width: '4px' },
              '&::-webkit-scrollbar-thumb': {
                bgcolor: '#BDC3C7',
                borderRadius: '4px',
              },
            }}
          >
            {this.state.results.map((col, idx) => (
              <Box
                key={idx}
                sx={{
                  minWidth: 280,
                  width: 280,
                  height: 'calc(100vh - 80px)',
                  bgcolor: '#F8F9FA',
                  borderRadius: 4,
                  p: 2,
                  flexShrink: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                }}
              >
                {/* Column Header */}

                <Box sx={{ flexShrink: 0 }}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle1" fontWeight="800" color="#1A2027" noWrap>
                      {col.checklistName}
                    </Typography>

                    <Stack direction="row" alignItems="center" spacing={1}>
                      {(col.checklistId == 3) &&
                        <>
                          {this.renderFilterHeader(col)}
                        </>
                      }
                      <Box sx={{
                        width: 22, height: 22, borderRadius: '50%', border: '1px solid #E0E0E0', bgcolor: 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', fontWeight: 700
                      }}>
                        {col.totalCount ?? 0}
                      </Box>
                    </Stack>
                  </Stack>

                  <Stack direction="row" alignItems="center" spacing={0.5} mb={1}>
                    <TrendingUpIcon sx={{ fontSize: 14, color: '#5F6368' }} />
                    <Typography variant="caption" color="text.secondary" fontWeight="500">
                      {col.totalCount > 0 ? '100%' : '0%'} avg completion
                    </Typography>
                  </Stack>

                  <LinearProgress
                    variant="determinate"
                    value={parseInt(col.totalCount > 0 ? '100%' : '0%')}
                    sx={{
                      height: 4, borderRadius: 2, mb: 3, bgcolor: '#E0E0E0',
                      '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #4A90E2, #9B51E0)' }
                    }}
                  />
                </Box>

                <Box sx={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: 'auto',
                  pr: 0.5,
                  scrollbarWidth: 'thin',
                  '&::-webkit-scrollbar': { width: '4px' },
                  '&::-webkit-scrollbar-thumb': {
                    bgcolor: '#BDC3C7',
                    borderRadius: '4px',
                  },
                }}>
                  {/* List of Users in this column */}
                  {
                    col.users.map((user) => (
                      <Box>
                        <Card
                          elevation={0}
                          sx={{
                            p: 2,
                            borderRadius: 3,
                            bgcolor: `${user.subStatus == 'Pending Sign' || user.subStatus == 'Failed' || user.subStatus == 'Cancelled' ? '#FFEBEE' : user.subStatus == 'Pending' ? '#FFFBEB' : ''}`, // Default yellowish
                            border: '1px solid #F0F0F0',
                            borderLeft: `5px solid ${user.subStatus == 'Pending Sign' || user.subStatus == 'Failed' || user.subStatus == 'Cancelled' ? '#D32F2F' : user.subStatus == 'Pending' ? '#FFC107' : 'var(--secondary-main)'}`,
                            mb: 2,
                          }}
                        >
                          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                            <Box>
                              <Typography variant="subtitle1" fontWeight="700" sx={{ fontSize: '0.95rem', textAlign: 'left' }}>
                                {user.firstName ? `${user.firstName} ${user.lastName}` : user.userName}
                              </Typography>
                              {/* <Typography variant="caption" color="text.secondary" display="block">
                            {'EAA-200'}
                          </Typography> */}
                            </Box>
                            {/* <Chip
                          label={'Low'}
                          size="small"
                          sx={{
                            bgcolor: '#FFEBEE',
                            color: '#D32F2F',
                            fontWeight: 'bold',
                            fontSize: '0.65rem',
                            height: 20,
                          }}
                        /> */}
                          </Stack>

                          {/* Conditional Buttons (for Authorization column style) */}

                          <Stack direction="row" spacing={1} mt={1}>
                            {/* <Button variant="outlined" size="small" sx={{ fontSize: '0.6rem', py: 0 }}>View</Button> */}
                            <Button variant="outlined" size="small" sx={{ fontSize: '0.6rem', py: 0 }}
                              onClick={() => this.sendEmail(user.userId)}
                            >Message</Button>
                            {user.personaInqId && (
                              <Button variant="outlined" size="small" sx={{ fontSize: '0.6rem', py: 0, color: '#2196F3' }}>
                                <Link
                                  href={`https://app.withpersona.com/dashboard/inquiries/${user.personaInqId}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  underline="hover"
                                  sx={{ color: '#2196F3' }}
                                >
                                  Persona
                                </Link>
                              </Button>
                            )
                            }
                          </Stack>


                          {/* Conditional Amount (for Account Review column style) */}
                          {user.totalAmountOwed && (
                            <Stack direction="row" justifyContent="space-between" mt={1.5}>
                              <Typography variant="caption" color="text.secondary">Amount Owed</Typography>
                              <Typography variant="caption" fontWeight="700">{amountFormat(Number(user.totalAmountOwed), 'en-US', 'USD')}</Typography>
                            </Stack>
                          )}


                          <Box sx={{ mt: 1.5 }}>
                            <Stack direction="row" justifyContent="space-between" mb={0.5}>
                              <Typography variant="caption" color="text.secondary" fontWeight="500">Sub-Status</Typography>
                              <Typography variant="caption" fontWeight="700">{user.subStatus}</Typography>
                            </Stack>
                            <LinearProgress
                              variant="determinate"
                              sx={{
                                height: 5, borderRadius: 3, bgcolor: '#e5e7eb',
                                '& .MuiLinearProgress-bar': { background: '#155dfc' }
                              }}
                              value={parseInt(user.subStatus == 'Pending' ? '1%' :
                                user.subStatus == 'Pending Sign' ? '40%' :
                                  user.subStatus == 'Signed' ? '80%' :
                                    user.subStatus == 'IRS Submitted' ? '90%' :
                                      user.subStatus == 'IRS Approved' ? '100%' :
                                        user.subStatus == 'Failed' ? '20%' :
                                          user.subStatus == 'Cancelled' ? '20%' :
                                            user.subStatus == 'Completed' || user.subStatus == 'Approved' ? '100%' : '0%')}
                            />
                          </Box>

                          <Collapse
                            in={this.state.expandedCards.includes(user.userId)}
                            timeout="auto"
                          >
                            <Box
                              sx={{
                                mt: 1.5,
                                pb: 1.5,
                                borderBottom: '1px solid #E0E0E0'
                              }}
                            >
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
                                <EmailOutlinedIcon
                                  sx={{
                                    fontSize: 18,
                                    color: '#757575'
                                  }}
                                />
                                <Typography variant="body2" sx={{ textAlign: 'left' }}>
                                  {user.email}
                                </Typography>
                              </Stack>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
                                <PhoneOutlinedIcon
                                  sx={{
                                    fontSize: 18,
                                    color: '#757575'
                                  }}
                                />
                                <Typography variant="body2" sx={{ mt: 0.5, textAlign: 'left' }}>
                                  {user.mobileNumber}
                                </Typography>
                              </Stack>
                            </Box>
                            {(user.form8821EnvelopeId && user.form8821Docusign) || (user.form433AEnvelopeId && user.form433ADocusign) ? <Stack direction="row" spacing={1} mt={1}>
                              {user.form8821EnvelopeId && user.form8821Docusign ? (<Button variant="outlined" size="small"
                                sx={{ fontSize: '0.6rem', py: 0, color: '#2196F3' }}
                                onClick={
                                  async () => {
                                    let body = {
                                      envelopeId: user.form8821EnvelopeId,
                                      isSubmittedtoIRS: 0,
                                      formType: 'form-8821'
                                    };
                                    this.downloadForm(body, user.email);
                                  }
                                }
                              >Form-8821</Button>
                              ) : (<></>)}
                              {(user.form433AEnvelopeId && user.form433ADocusign) ? (<Button variant="outlined" size="small" sx={{ fontSize: '0.6rem', py: 0, color: '#2196F3' }}
                                onClick={
                                  async () => {
                                    let body = {
                                      envelopeId: user.form433AEnvelopeId,
                                      isSubmittedtoIRS: 0,
                                      formType: 'form-433A'
                                    };
                                    this.downloadForm(body, user.email);
                                  }
                                }
                              >Form-433A</Button>
                              ) : (<></>)}
                            </Stack> : (<></>)
                            }
                            {(user.form8821EnvelopeId && user.form8821Docusign && user.isForm8821Approved) || (user.form433AEnvelopeId && user.form433ADocusign) ? <Stack direction="row" spacing={1} mt={1} sx={{
                              pb: 1,
                              borderBottom: '1px solid #E0E0E0'
                            }}>
                              {user.form8821EnvelopeId && user.form8821Docusign && user.isForm8821Approved ? (<Button variant="outlined" size="small"
                                sx={{ fontSize: '0.6rem', py: 0 }}
                                onClick={() => this.openTranscriptDashboard(user)}
                              >Tax Summary</Button>
                              ) : (<></>)}
                              {(user.form433AEnvelopeId && user.form433ADocusign) ? (<Button variant="outlined" size="small" sx={{ fontSize: '0.6rem', py: 0 }}
                                onClick={() => this.openUserEligiblePlans(user)}
                              >View Plans</Button>
                              ) : (<></>)}
                            </Stack> : (<></>)
                            }
                            <Stack direction="row" spacing={1} mt={1} sx={{
                              pb: 1,
                              borderBottom: '1px solid #E0E0E0'
                            }}>
                              <Button variant="outlined" size="small" sx={{ fontSize: '0.6rem', py: 0 }}
                                onClick={() => this.handleDeactivateUser(user)}
                              >Deactivate</Button>
                            </Stack>
                            {/* <Box
                            sx={{
                              mt: 1.5,
                              pb: 1.5,
                              borderBottom: '1px solid #E0E0E0'
                            }}
                          >
                            <Box sx={{ backgroundColor: '#F6F6FF', p: 1 }}>
                              <Stack direction="row" alignItems="flex-start" spacing={1}>
                                <TrendingUpOutlinedIcon
                                  sx={{
                                    fontSize: 18,
                                    color: '#757575'
                                  }}
                                />
                                <Typography variant="body2" sx={{ mt: 0.5, textAlign: 'left' }}>
                                  {user.helpText}
                                </Typography>
                              </Stack>
                            </Box>
                          </Box> */}
                          </Collapse>

                          <Box sx={{ textAlign: 'center', mt: 2 }}>
                            <IconButton size="small" sx={{ color: '#1976D2', p: 0 }} onClick={() => this.toggleCard(user.userId)}>
                              <Typography variant="caption" fontWeight="600" sx={{ mr: 0.2 }}>{this.state.expandedCards.includes(user.userId) ? "Less" : "More"}</Typography>
                              {this.state.expandedCards.includes(user.userId) ? (
                                <KeyboardArrowUpIcon sx={{ fontSize: '1rem' }} />
                              ) : (
                                <KeyboardArrowDownIcon sx={{ fontSize: '1rem' }} />
                              )}
                            </IconButton>
                          </Box>
                        </Card>
                      </Box>
                    ))
                  }
                  {
                    col.users.length >= 5 && col.hasLoadMore && (
                      <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        sx={{ mt: 1 }}
                        onClick={() => this.handleLoadMore(col)}
                      >
                        Load More
                      </Button>
                    )
                  }
                </Box>
              </Box>
            ))}
          </Stack >
        </Box >
      </>
    );
  }

  getCaseDashboardDetails(searchText: string = "") {
    const postData = {
      limit: '5',
      offset: '0',
      searchFilter: searchText
    };
    DashboardServices.getCaseDashboardDetails(this.state.accessToken, postData).then((r: any) => {
      if (r.ok) {
        r.json().then((resp: DashboardColumn[]) => {
          // this.setState({results: resp})
          const results = resp.map((col: DashboardColumn) => ({
            ...col,
            currentPage: 1,
            hasLoadMore: col.users.length > 0
          }));

          this.setState({ results });
        });
      }

    });
  }

  getPagingCaseDashBoard(caseListId: number = 1, searchText: string = "", additionalFilters: any = null, isAdditionalFilter: boolean = false) {
    const checklist = this.state.results.find(
      x => x.checklistId === caseListId
    );

    if (!checklist) return;

    // let pageIndex: number = (this.state.currentPage);
    // this.setState({currentPage: pageIndex + 1});
    const postPageData = {
      caseListId: caseListId,
      limit: '5',
      offset: checklist.currentPage * 5,
      searchFilter: searchText,
      additionalFilters: this.state.selectedFilters || null,
    };
    if (isAdditionalFilter) {
      postPageData.additionalFilters = additionalFilters;
      postPageData.offset = 0;
    }
    DashboardServices.getPagingCaseDashBoard(this.state.accessToken, postPageData).then((r: any) => {
      if (r.ok) {
        r.json().then((resp: any) => {
          // this.setState({results: resp});
          const updatedChecklist = resp[0];
          this.setState(prevState => ({
            results: prevState.results.map(col => {
              if (col.checklistId === caseListId) {
                return {
                  ...col,
                  users: isAdditionalFilter ? updatedChecklist.users : [...col.users, ...updatedChecklist.users],
                  totalCount: updatedChecklist.totalCount,
                  currentPage: isAdditionalFilter ? 1 : col.currentPage + 1,
                  hasLoadMore: isAdditionalFilter ? updatedChecklist.users.length < updatedChecklist.totalCount : col.users.length + updatedChecklist.users.length < updatedChecklist.totalCount
                };
              }
              return col;
            })
          }));
        });
      }
    });
  }

  sendEmail = async (userId: any) => {
    const { subject, body } = this.state;
    // Email instructions only for imported users with claims
    const result = await Swal.fire({
      title: "Send Email",
      html: `<div id="emailFields">
                <input 
                    id="swal-subject" 
                    class="swal2-input" 
                    placeholder="Enter Subject"
                    value="${subject}"
                    style="
                        width: 100%;
                        margin: 10px 0;
                        box-sizing: border-box;
                    "
                />

                <textarea 
                    id="swal-body" 
                    class="swal2-textarea" 
                    placeholder="Enter Email Body"
                    style="
                        width: 100%;
                        height: 150px;
                        margin: 10px 0;
                        box-sizing: border-box;
                    "
                >${body}</textarea>
            </div>`,
      showCancelButton: true,
      confirmButtonText: "Send",

      didOpen: () => {

        const subjectInput = document.getElementById("swal-subject");
        const bodyInput = document.getElementById("swal-body");

        subjectInput?.addEventListener("input", (e) => {
          // Clear any validation message
          Swal.resetValidationMessage();

          this.setState({
            subject: (e.target as HTMLInputElement).value
          });
        });

        bodyInput?.addEventListener("input", (e) => {
          // Clear any validation message
          Swal.resetValidationMessage();

          this.setState({
            body: (e.target as HTMLTextAreaElement).value
          });
        });
      },

      preConfirm: () => {

        const sendInstruction = (
          document.getElementById("sendInstruction") as HTMLInputElement
        )?.checked;
        // Validation occurs only Send Email Instructions field is unchecked
        if (!sendInstruction && (!this.state.subject || !this.state.body)) {
          Swal.showValidationMessage(
            "Subject and Body are required"
          );
          return false;
        }

        return true;
      },
    });

    if (result.isConfirmed) {

      const payload = {
        userIds: [userId],
        emailSubject: this.state.subject,
        emailBody: this.state.body
      };

      ProfileServices.sendCustomEmail(payload, this.state.accessToken).then(r => {
        if (r.ok) {
          r.json().then(response => {
            ShowAlert("Success", "Email sent successfully", "success").then(r => {
            });
          });
        }
      });

      this.setState({
        subject: "",
        body: ""
      });
    }
  };

  /**
   * Below function is used to deactivate the user
   * @param user - respective row details for which the deactivate button is clicked
   */
  async handleDeactivateUser(user: DashboardUser) {
    Swal.fire({
      title: `Deactivate User?`,
      html: `
                  <div style="text-align: left;">
                      <p>Are you sure you want to deactivate <b>${user.userName}</b> (<b>${user.email}</b>)?</p>
                  </div>
              `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.confirmDeactivateUser(user);
      }
    });
  }

  /**
   * Below function is used to confirm deactivation of the user
   * @param user - respective row details for which the deactivate button is clicked
   */
  async confirmDeactivateUser(user: DashboardUser) {
    Swal.fire({
      title: `Confirm Deactivation`,
      html: `
                  <div style="text-align: left;">
                      <p>This action will immediately restrict the user's access. Please confirm you want to proceed with deactivating <b>${user.userName}</b> (<b>${user.email}</b>).</p>
                  </div>
              `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Deactivate User',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deactivateUser(user.userId);
      }
    });
  }

  /**
   * Below function is used to deactivate the user
   * @param userId - userId of the user to be deactivated
   */
  deactivateUser(userId: string) {
    let payload = {
      userId: userId
    };
    ProfileServices.updateUserStatus(payload, this.state.accessToken).then((r) => {
      if (r.ok) {
        r.json().then((resp) => {

          Swal.fire({
            icon: "success",
            title: "Success",
            text: "User deactivated successfully.",
          }).then((result) => {
            if (result.isConfirmed) {
              this.getCaseDashboardDetails();
            }
          });
        });
      }
    });
  }

  /**
   * Below function is used to open the transcript dashboard for the user
   * @param user - respective row details for which the transcript dashboard button is clicked
   */
  async openTranscriptDashboard(user: DashboardUser) {
    Swal.fire({
      title: 'Transcript Dashboard',
      html: `<div id="csedd-details-root"></div>`,
      width: '90%',
      showCloseButton: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const container = document.getElementById('csedd-details-root');
        if (container) {
          const root = createRoot(container);
          root.render(<CSEDDetails userId={user.userId} userName={user.userName} />);
        }
      },
      willClose: () => {
        const container = document.getElementById('csedd-details-root');
        if (container) {
          container.innerHTML = ''; // cleanup
        }
      }
    });
  }

  /**
   * Below function is used to open the user eligible plans for the user
   * @param user - respective row details for which the view plans button is clicked
   */
  async openUserEligiblePlans(user: DashboardUser) {
    Swal.fire({
      title: 'Eligible Plans',
      html: `<div id="eligible-plans-root"></div>`,
      width: '90%',
      showCloseButton: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const container = document.getElementById('eligible-plans-root');
        if (container) {
          const root = createRoot(container);
          root.render(<UserEligiblePlans userId={user.userId} userName={user.userName} />);
        }
      },
      willClose: () => {
        const container = document.getElementById('eligible-plans-root');
        if (container) {
          container.innerHTML = ''; // cleanup
        }
      }
    });
  }

  /**
       * Below function download the form-8821/form-433A of the user 
       * @param row - respective row details for which the download button is clicked
       */
  private async downloadForm(body: any, email: string) {

    try {
      FormServices.downloadDocusignedPDF(body, this.state.accessToken).then((r) => {
        if (r.ok) {
          r.json().then((response) => {

            const byteCharacters = atob(response.body);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], { type: response.headers['Content-Type'] });

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${email}_${body.formType}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

          });
        }
      });

    } catch (error: any) {
      console.error('Error downloading the file:', error.response?.data || error.message);
      ShowBlocker(false);
    }
  }
}

export default CaseDashboard;